import Vue from 'vue'
import Vuex from 'vuex'
import conversation from './modules/conversation.js'
import group from './modules/group'
import user from './modules/user'
import global from './modules/global'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		conversation,
		group,
		user,
		global
	},
	state: {
		sdk_ready: false,
		navStatus: 1, //导航栏状态 1首页 2搜索 3公司 4政策中心
		isLoginDialogOpen: false, //登录弹出框的状态
		isMineDialogOpen:false,//我的弹出框状态
		isTopUpDialogOpen: false, //充值弹出框的状态
		isLogin:0,//点开登录前的按钮的状态 1是用户 2是公司
		standing:'user',//身份  user是用户 company是公司
		token:'',
		userinfo:'',//个人信息,
		loading:false,//切换身份时显示的全局图标
		deliverPending:0,//投递管理未处理消息数
		joinPending:0,//申请加入公司待处理数
		invitePending:0,//邀请面试待处理
		waitPending:0,
	},
	mutations: {
		changeInterviewPending(state, obj){
			if(obj.invite||obj.invite===0) state.invitePending=obj.invite
			if(obj.wait||obj.wait===0) state.waitPending=obj.wait
		},
		changeJoinPending(state, num){
			state.joinPending = num
		},
		changeDeliverPending(state, num){
			state.deliverPending = num
		},
		//腾讯im SDK状态
		changeSdkReady(state, sdk_ready) {
			state.sdk_ready = sdk_ready
		},
		changNav(state, value) {
			state.navStatus = value
		},
		changeLoginDialog(state,value){
			state.isLoginDialogOpen = value;
		},
		changeMineDialog(state,value){
			state.isMineDialogOpen = value;
		},
		changeTopUpDialog(state,value){
			state.isTopUpDialogOpen = value;
		},
		changeToken(state,value){
			state.token=value
		},
		changeinfo(state,value){
			state.userinfo=value
		},
		changeLogin(state,value){
			state.isLogin=value
		},
		changeStanding(state,value){
			state.standing=value
		},
		changeLoading(state,value){
			state.loading=value
		},
	}
})
